import { CaretRightIcon } from '@phosphor-icons/react';

import { Pill } from '@/components/ui/pill';
import type { PillProps } from '@/components/ui/pill';

interface NotificationCardProps {
  title: string;
  body: string;
  formattedDate: string;
  typeLabel: string;
  pillVariant: PillProps['variant'];
  isRead: boolean;
  isClickable: boolean;
  onOpenDestination?: () => void;
}

export function NotificationCard({
  title,
  body,
  formattedDate,
  typeLabel,
  pillVariant,
  isRead,
  isClickable,
  onOpenDestination,
}: NotificationCardProps) {
  const cardContent = (
    <>
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex min-w-0 items-center gap-3">
          <Pill variant={pillVariant}>{typeLabel}</Pill>
          {!isRead && <span className="h-2.5 w-2.5 rounded-full bg-red-400" />}
        </div>

        <div className="flex shrink-0 items-center gap-2">
          <span className="text-small text-slate-400 whitespace-nowrap">
            {formattedDate}
          </span>
          {isClickable && (
            <CaretRightIcon
              size={18}
              weight="bold"
              className="text-slate-300"
              aria-hidden="true"
            />
          )}
        </div>
      </div>

      <h2 className="mb-2 text-large text-slate-50 break-words [overflow-wrap:anywhere]">
        {title}
      </h2>
      <p className="text-body whitespace-pre-line text-slate-300 break-words [overflow-wrap:anywhere]">
        {body}
      </p>
    </>
  );

  return (
    <article
      className={`rounded-2xl border bg-slate-600 p-4 transition-colors ${
        isRead
          ? 'border-slate-600'
          : 'border-sky-400/60 shadow-[0_0_0_1px_rgba(56,189,248,0.08)]'
      }`}
    >
      {isClickable && onOpenDestination ? (
        <button
          type="button"
          onClick={onOpenDestination}
          className="w-full appearance-none border-0 bg-transparent p-0 text-left"
        >
          {cardContent}
        </button>
      ) : (
        <div>{cardContent}</div>
      )}
    </article>
  );
}
